import React from 'react';

const Close = () => {
  return (
    <svg width="29.25" height="29.25" viewBox="0 0 29.25 29.25">
      <g id="Icon_ionic-md-close-circle-outline" data-name="Icon ionic-md-close-circle-outline" transform="translate(-3.375 -3.375)">
        <path id="Path_1674" data-name="Path 1674" d="M18,6.328A11.667,11.667,0,1,1,9.745,9.745,11.623,11.623,0,0,1,18,6.328m0-2.953A14.625,14.625,0,1,0,32.625,18,14.623,14.623,0,0,0,18,3.375Z" fill="#ec1c24"/>
        <path id="Path_1675" data-name="Path 1675" d="M25.313,23.266l-2.046,2.046L18,20.046l-5.266,5.266-2.046-2.046L15.954,18l-5.266-5.266,2.046-2.046L18,15.954l5.266-5.266,2.046,2.046L20.046,18Z" fill="#ec1c24"/>
      </g>
    </svg>
  );
}

export default Close;